const finalTrial = {
  typeInfo: "noQuestions",
  title: "Combinação perfeita para aulas online! 🎉",
  subtitle:
    "Parece que o formato de aulas com professor pode ser adequado para seu filho/sua filha: vocês têm a possibilidade técnica, um interesse claro em aulas regulares e condições adequadas para começar. Experimentem começar com a primeira aula gratuita!",
  button: "Experimentar grátis 🚀",
  nextStep: 7,
};

export default {
  newDesign: true,
  parameters: {
    landing_id: "GRBrQv43",
    success_page: 'success_long_new_design',
    segment: 55,
  },
  title: "Encontre o formato de aprendizagem ideal para seu filho/a | Kodland",
  downtimeUrl: "https://www.kodland.org/pt",
  startPage: {
    title:
      "Responda a estas 5 perguntas e receba uma aula gratuita para seu filho ou sua filha",
    subtitle:
      "Seu filho ou sua filha vai aprender programação e criar videogames e animações.",
    image: {
      url: "/welcome/fwd_latam_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/fwd_latam_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Pressione para continuar 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Obrigado por confiar em nossa plataforma educacional!",
    subtitle:
      "Infelizmente, tablets ou telefones não são adequados para assistir às nossas aulas. Ficaremos felizes em vê-lo em nossas aulas na próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Se as aulas forem úteis para a criança, vocês estariam dispostos a considerar aulas regulares?",
      answers: [
        {
          answer: "Sim, já estamos considerando essa possibilidade.",
          nextStep: 2,
        },
        {
          answer: "Sim, se o preço for razoável.",
          nextStep: 2,
        },
        {
          answer: "Ainda não temos certeza, precisamos de mais informações.",
          nextStep: 2,
        },
        {
          answer: "Não, não planejamos pagar, mesmo que a criança goste.",
          nextStep: 2,
        },
      ],
    },
    2: {
      question: "Vocês têm um computador ou notebook em casa para as aulas?",
      answers: [
        { answer: "Sim, temos um computador ou notebook.", nextStep: 3 },
        { answer: "No momento, temos apenas celular ou tablet.", nextStep: 3 },
      ],
    },
    3: {
      question: "Quão estável é a conexão de internet em casa?",
      answers: [
        { answer: "Estável, normalmente sem problemas.", nextStep: 4 },
        { answer: "Às vezes cai.", nextStep: 4 },
        { answer: "Cai com frequência.", nextStep: 4 },
      ],
    },
    4: {
      question:
        "Qual orçamento mensal para o desenvolvimento da criança vocês consideram confortável?",
      financial: true,
      answers: [
        { answer: "Até 30 USD.", nextStep: 5 },
        { answer: "30–60 USD.", nextStep: 5 },
        { answer: "60–100 USD.", nextStep: 5 },
        { answer: "Mais de 100 USD.", nextStep: 5 },
      ],
    },
    5: {
      question: "A criança já teve experiência com aulas online?",
      answers: [
        { answer: "Não, ainda não teve.", nextStep: 6 },
        { answer: "Sim, uma vez ou por pouco tempo.", nextStep: 6 },
        { answer: "Sim, faz aulas online regularmente.", nextStep: 6 },
      ],
    },

    6: finalTrial,

    7: {
      title: "Quantos anos tem o seu filho/sua filha?",
      subtitle:
        "Escolheremos o curso que melhor se adapta à idade do seu filho/sua filha.",
      type: "age",
      button: "",
    },
    8: {
      title: "Agende uma aula gratuita",
      type: "one-page-contacts",
      subtitle:
        "Vamos nos conhecer, ver o que vamos aprender e como a aula funciona.",
      button: "Quase lá! 🔥",
    },
    9: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    10: {
      title: "Lembrete rápido antes da sua aula experimental ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Por favor, entre na aula a partir de um computador ou notebook e acompanhe seu filho/sua filha durante toda a aula. A aula experimental é individual e personalizada.",
      button: "O que mais?",
    },
    11: {
      title:
        "Manteremos contato por e-mail e WhatsApp antes da sua aula. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Enviaremos um lembrete 24 horas antes da aula e pediremos para você confirmar 2 horas antes. Manter contato nos ajuda a garantir que a aula aconteça conforme o planejado.",
      button: "O que mais?",
    },
    12: {
      title: "A aula vai acontecer na nossa plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
      button: "Entendi ✅",
    },
  },
};
